<script>
	import { onMount } from 'svelte';
	
	export let html;
	let div;
	
	function animateImagesIfInView() {
		
		if (div === null) {
			return;
		}

		if (!div.querySelectorAll('div.withCustomCss_set') || !div.querySelectorAll('div.withoutCustomCss_set')) {
			requestAnimationFrame(animateImagesIfInView);
			return;
		}

		const content = document.querySelector('.content');
		const useCustomCss = document.body.classList.contains('useCustomCss');
		const selector = `div.${useCustomCss ? 'withCustomCss' : 'withoutCustomCss'}_set`;
		const images = Array.from(div.querySelectorAll(selector));
		const usePercentageOfView = 50;
		const reachedInDiff = content.getBoundingClientRect().height * ((100 - usePercentageOfView) / 100);

		const contentTop = content.getBoundingClientRect().y;
		const contentBottom = contentTop + content.getBoundingClientRect().height;

		// image
		const divTop = div.getBoundingClientRect().y;
		const divBottom = divTop + div.getBoundingClientRect().height;

		// checking if the image is within the percentage of the viewport
		const upperEdgeInView = divTop < contentBottom - reachedInDiff;
		const bottomEdgeInView = contentTop + reachedInDiff < divBottom;
		if (upperEdgeInView && bottomEdgeInView) {
			images.forEach(image => {
				image.classList.add('color_in');
			});
		}
		else {
			images.forEach(image => {
				image.classList.remove('color_in');
			});
		}

		// to minimize the repetitions
		setTimeout(() => {
			requestAnimationFrame(animateImagesIfInView);
		}, 500);
	}
	function loadLogoWall() {
		
		if (!div.querySelector('div')) {
			requestAnimationFrame(loadLogoWall);
			return;
		}
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;
		tempDiv.querySelector('div').getAttribute('class').split(' ').map(className => {
			div.classList.add(className);
		});
		const dataElement = tempDiv.querySelector('[data-cols-mobile]');
		const logoWallDiv = div.querySelector('div');
		let images = div.querySelectorAll('img');
		// sort alphabetically, sorting inside DIV comes afterwards:
		const imagesSorted = Array.from(images).sort((a,b) => {
			let firstImageSrc = a.src.split('/');
			firstImageSrc = firstImageSrc[firstImageSrc.length - 1].replace(/\W/g, '');
			let lastImageSrc = b.src.split('/');
			lastImageSrc = lastImageSrc[lastImageSrc.length - 1].replace(/\W/g, '');
			return firstImageSrc.localeCompare(lastImageSrc, 'de', { numeric: true });
		});
		//for DESC use imagesSorted.reverse()
		imagesSorted.forEach(img => {
			div.querySelector('div').insertAdjacentElement('beforeend', img.parentElement.parentElement);
		});
		if (dataElement && logoWallDiv) {
			logoWallDiv.style.setProperty('--cols-mobile', dataElement.getAttribute('data-cols-mobile'));
			logoWallDiv.style.setProperty('--cols-tablet', dataElement.getAttribute('data-cols-tablet'));
			logoWallDiv.style.setProperty('--cols-desktop', dataElement.getAttribute('data-cols-desktop'));

			// adding empty Divs to get rid of eventual grey space
			let addMobile = logoWallDiv.childElementCount % dataElement.getAttribute('data-cols-mobile');
			if(addMobile > 0) {
				addMobile =  dataElement.getAttribute('data-cols-mobile') - addMobile;
			}
			let addTablet = logoWallDiv.childElementCount % dataElement.getAttribute('data-cols-tablet');
			if(addTablet > 0) {
				addTablet =  dataElement.getAttribute('data-cols-tablet') - addTablet;
			}
			let addDesktop = logoWallDiv.childElementCount % dataElement.getAttribute('data-cols-desktop');
			if(addDesktop > 0) {
				addDesktop =  dataElement.getAttribute('data-cols-desktop') - addDesktop;
			}
			const addEmptyDiv = (className) => {
				const emptyDiv = document.createElement('div');
				emptyDiv.classList.add(className);
				logoWallDiv.append(emptyDiv);
			}
			for(let i = 0; i < addMobile; i++) {
				addEmptyDiv('empty_mobile')
			}
			for(let i = 0; i < addTablet; i++) {
				addEmptyDiv('empty_tablet')
			}
			for(let i = 0; i < addDesktop; i++) {
				addEmptyDiv('empty_desktop')
			}
		}
		images = div.querySelectorAll('img');
		Array.from(images).forEach(img => {
			img.onload = () => {
				// //is Img:
				// if (img.parentElement.nextElementSibling &&
				// 	img.parentElement.nextElementSibling.classList.contains('grey')) {
				// 	img.parentElement.parentElement.classList.add('grey_set');
				// }
				// //is Link:
				if (img?.parentElement?.classList.contains('withCustomCss')) {
					img.parentElement.parentElement.classList.add('withCustomCss_set');
				}
				if (img?.parentElement?.classList.contains('withoutCustomCss')) {
					img.parentElement.parentElement.classList.add('withoutCustomCss_set');
				}
				img.remove();
			}
			img.parentElement.style.backgroundImage = `url('${img.src}')`;
		})

		animateImagesIfInView();
	}
	
	onMount(() => {
		loadLogoWall();
	});
</script>

<div bind:this={div} class="logowall marginbox">
	<slot/>
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	.logowall {
		width: 100%;
		--cols-mobile: 1;
		--cols-desktop: 2;
		--padding: 40px;
		margin: 0 $spacing-mobile $spacing-mobile $spacing-mobile;
		
		> div {
			display: grid;
			grid-template-columns: repeat(var(--cols-mobile), 1fr);
			
			background: #aaa;
			gap: 1px;
			padding: 1px;
			
			.empty_mobile {
				display: block;
			}
			.empty_tablet, .empty_desktop {
				display: none;
			}
			
			@include for-tablet-portrait-up {
				grid-template-columns: repeat(var(--cols-tablet), 1fr);
				
				.empty_tablet {
					display: block;
				}
				.empty_mobile, .empty_desktop {
					display: none;
				}
			}
			
			@include for-tablet-landscape-up {
				grid-template-columns: repeat(var(--cols-desktop), 1fr);
				
				.empty_desktop {
					display: block;
				}
				.empty_mobile, .empty_tablet {
					display: none;
				}
			}
			
			> div {
				aspect-ratio: 1;
				
				padding: calc(var(--padding) * .5);
				background-color: white;
				background-repeat: no-repeat;
				background-size: 80% auto, auto 80%;
				position: relative;
				background-position: center;
				transition: filter var(--animation-duration) ease-in-out;
				
				@include for-tablet-portrait-up {
					padding: var(--padding);
				}
				
				&.withCustomCss_set .color {
					z-index: 1;
					opacity: 0;
					transition: opacity var(--animation-duration) ease-in-out;
				}

				.withCustomCss,
				.withoutCustomCss {
					opacity: 1;
					transition: opacity var(--animation-duration) ease-in-out;
				}
				
				&.color_in .color {
					opacity: 1;
				}
				&.color_in .withCustomCss,
				&.color_in .withoutCustomCss {
					opacity: 0;
				}
			}
		}
		
		h3 {
			margin: 0 0 $spacing-mobile 0;
		}
		
		.color,
		.withCustomCss,
		.withoutCustomCss {
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			position: absolute;
			
			width: calc(100% - var(--padding));
			height: calc(100% - var(--padding));
			top: calc(var(--padding) * .5);
			left: calc(var(--padding) * .5);
			
			@include for-tablet-portrait-up {
				width: calc(100% - (var(--padding) * 2));
				height: calc(100% - (var(--padding) * 2));
				top: var(--padding);
				left: var(--padding);
			}
		}
		
		.color a {
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			position: absolute;
			
			width: 100%;
			height: 100%;
		}

		.empty_mobile, .empty_tablet, .empty_desktop {
			background: var(--color-burgeins-4);
			padding: 0;
			box-shadow: 2px 0 0 2px var(--color-burgeins-4);
			z-index: 1;
		}

		> div > div:not(.empty_mobile):nth-of-type(n+3) ~ .empty_mobile,
		> div > div:not(.empty_mobile):not(.empty_tablet):nth-of-type(n+4) ~ .empty_tablet,
		> div > div:not(.empty_mobile):not(.empty_tablet):not(.empty_desktop):nth-of-type(n+5) ~ .empty_desktop {
			box-shadow: 2px 2px 0 2px var(--color-burgeins-4);
			background: var(--color-burgeins-4);
		}
	}
	
	.useCustomCss .logowall {
		.withoutCustomCss {
			opacity: 0;
		}
	}

	.useCustomCss .logowall .empty_mobile,
	.useCustomCss .logowall .empty_tablet,
	.useCustomCss .logowall .empty_desktop {
		background: var(--custom-background-color, black);
		box-shadow: 2px 0 0 2px var(--custom-background-color, black);
	}

	.useCustomCss .logowall > div > div:not(.empty_mobile):nth-of-type(n+3) ~ .empty_mobile,
	.useCustomCss .logowall > div > div:not(.empty_mobile):not(.empty_tablet):nth-of-type(n+4) ~ .empty_tablet,
	.useCustomCss .logowall > div > div:not(.empty_mobile):not(.empty_tablet):not(.empty_desktop):nth-of-type(n+5) ~
	.empty_desktop {
		box-shadow: 2px 2px 0 2px var(--custom-background-color, black);
		background: var(--custom-background-color, black);
	}
</style>
